import { debounce, checkMobileOrDesktopHeader } from './helper';

function toggleMenuDesktop () {
  const bg = document.getElementById('menuDesktop');
  const btnShowNavDesk = document.getElementById('btnShowNavDesk');
  if (bg.style.display === 'block') {
    bg.style.display = 'none';
    btnShowNavDesk.style.opacity = '1';
    bg.setAttribute('aria-hidden', true);
    document.body.classList.remove('overflow-y-hidden');
  } else {
    bg.style.display = 'block';
    btnShowNavDesk.style.opacity = '0';
    bg.setAttribute('aria-hidden', false);
    document.body.classList.add('overflow-y-hidden');
  }
}

function showMenuMobile () {
  document.getElementById('menuMobile').style.transform = 'translateX(0)';
  document.getElementById('menuMobile').style.display = 'block';
  document.getElementById('menuMobile').setAttribute('aria-hidden', false);
}

function closeMenuMobile () {
  document.getElementById('menuMobile').style.transform = 'translateX(-100%)';
  document.getElementById('menuMobile').setAttribute('aria-hidden', true);
}

document.getElementById('btnShowNavDesk').addEventListener('click', toggleMenuDesktop);
document.getElementById('btnHideNavDesk').addEventListener('click', toggleMenuDesktop);
document.getElementById('btnShowNavMobile').addEventListener('click', showMenuMobile);
document.getElementById('btnHideNavMobile').addEventListener('click', closeMenuMobile);

// Change Logo/Menu to black on white bg & hide Logo Text after scrolling past header
const stickyNavWhite = document.querySelector('#sticky-nav.white');
const logoText = document.querySelector('#sticky-nav svg g#logo-text');
let header = checkMobileOrDesktopHeader();

const changeNavColorOnScroll = debounce(() => {
  header = checkMobileOrDesktopHeader();
  observer.observe(header);
}, 200);

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      logoText.style.opacity = '1';
      if (stickyNavWhite) {
        stickyNavWhite.classList.remove('red');
        stickyNavWhite.classList.add('white');
      }
    } else {
      logoText.style.opacity = '0';
      if (stickyNavWhite) {
        stickyNavWhite.classList.remove('white');
        stickyNavWhite.classList.add('red');
      }
    }
  });
}, { threshold: 0.09 });
changeNavColorOnScroll();
window.addEventListener('resize', changeNavColorOnScroll);
